module.exports = __webpack_public_path__ + "static/media/AFP-ERP-1.0c791369.jpg";